// Turbo (Drive, Frames)
import "@hotwired/turbo-rails"
// Rails UJS (to use link_to with method: "XYZ")
import Rails from "@rails/ujs"
// Stimulus
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

import application from "../src/stimulus"

application.load(definitionsFromContext(require.context("../controllers", true, /\.js$/)))

Rails.start()
